import { render } from "./KeyF1.vue?vue&type=template&id=6b7612dc"
import script from "./KeyF1.vue?vue&type=script&lang=ts"
export * from "./KeyF1.vue?vue&type=script&lang=ts"
script.render = render

export default script